import { render, staticRenderFns } from "./incl-product-info.vue?vue&type=template&id=42c207a8&scoped=true"
import script from "./incl-product-info.vue?vue&type=script&lang=js"
export * from "./incl-product-info.vue?vue&type=script&lang=js"
import style0 from "./incl-product-info.vue?vue&type=style&index=0&id=42c207a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c207a8",
  null
  
)

export default component.exports